import React from 'react';
import { Outlet } from 'react-router-dom';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      {/* Background Decor (Subtle) */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-[400px] bg-[#0B1221]"></div>
        <div className="absolute top-[300px] left-0 w-full h-[200px] bg-gradient-to-b from-[#0B1221] to-transparent"></div>
      </div>

      {/* Main Content Area */}
      <main className="relative z-10 flex-grow flex flex-col min-h-screen">
        <div className="max-w-[1280px] mx-auto w-full px-4 sm:px-6 lg:px-8 py-6 flex-grow flex flex-col">
          <Outlet />
        </div>

        {/* Corporate Footer */}
        <footer className="mt-auto py-10 px-4">
          <div className="max-w-[1240px] mx-auto border-t border-slate-200 pt-8 flex flex-col items-center gap-4">
            <p className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-400">
              Powered by BPA Solutions
            </p>
            <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3 text-xs font-bold text-slate-500">
              <a href="mailto:support@bpasolutions.au" className="hover:text-brand-blue transition-colors">support@bpasolutions.au</a>
              <span className="hidden sm:block w-1 h-1 bg-slate-300 rounded-full"></span>
              <a href="tel:+61425228778" className="hover:text-brand-blue transition-colors">+61 425 228 778</a>
              <span className="hidden sm:block w-1 h-1 bg-slate-300 rounded-full"></span>
              <a href="https://www.bpasolutions.au" target="_blank" rel="noreferrer" className="hover:text-brand-blue transition-colors">www.bpasolutions.au</a>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}